import React from "react";
//Limitless imports
import { useNotificationContext } from "@limitless/common/hooks/notification/NotificationContext";
import { findExpertMessageList } from "@limitless/expert/apis/expert-rating-api/ExpertRatingAPI";
import { useTranslation } from "@limitless/common/hooks";
import { useExpertProfileContext } from "../expert-profile/ExpertProfileContext";
import { fetchExpertRatingMessage } from "../../apis/expert-rating-api/ExpertRatingAPI";
const RATING_INITIAL_STATE = {
  loading: false,
  history: [],
  filtered: [],
  hasError: false
};
const RATING_FILTERS_INITIAL_STATE = {
  custRatingHundred: false,
  custRatingEighty: false,
  custRatingFifty: false,
  custRatingZero: false,
  qualityRatingHundrad: false,
  qualityRatingEighty: false,
  qualityRatingFifty: false,
  qualityRatingZero: false
};
const RATING_SORT_INITIAL_STATE = {
  dateSort: false,
  custRatingSort: false,
  qualityRatingSort: false,
  cusrRatingSortDESC: false,
  qualityRatingSortDESC: false,
  dateSortDESC: false
};
const UPDATE_RATING_MESSAGES = "update-messages";
const RESET_RATING_MESSAGES = "reset-messages";
const SET_RATING_MESSAGES = "load-messages";
const UPDATE_MESSAGES_FILTERS = "update-rating-messages-filters";
const RESET_MESSAGES_FILTERS = "reset-rating-messages-filters";
const RESET_MESSAGES_SORT = "reset-rating-messages-sort";
const RESET_MESSAGES_ALL = "reset-rating-messages";
const filterRange = {
  eighty: {
    max: 100,
    min: 80
  },
  fifty: {
    max: 80,
    min: 50
  },
  zero: {
    max: 50,
    min: 0
  }
};
const ratingReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_RATING_MESSAGES:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    case SET_RATING_MESSAGES:
      return {
        ...state,
        loading: true
      };
    case RESET_RATING_MESSAGES:
      return RATING_INITIAL_STATE;
    default:
      throw new Error(`Unsupported rating message action type ${action.tyoe}`);
  }
};
const ratingMessagesFilterReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_MESSAGES_FILTERS:
      return {
        ...state,
        ...action.payload
      };
    case RESET_MESSAGES_FILTERS:
      return {
        ...state,
        ...RATING_FILTERS_INITIAL_STATE
      };
    case RESET_MESSAGES_SORT:
      return {
        ...state,
        ...RATING_SORT_INITIAL_STATE
      };
    case RESET_MESSAGES_ALL:
      return {
        ...RATING_FILTERS_INITIAL_STATE,
        ...RATING_SORT_INITIAL_STATE
      };
    default:
      throw new Error(`Unsupported rating message action type ${action.tyoe}`);
  }
};
export const useExpertRatingDashboard = () => {
  const [group, setGroup] = React.useState();
  const [sort, setSort] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const [filters, setFilters] = React.useState([]);
  const [custRating, setCustRating] = React.useState(0);
  const [pageCount, setPageCount] = React.useState(0);
  const [ratingMessage, setRatingMessage] = React.useState({});
  const [ratingMessagesCount, setRatingMessagesCount] = React.useState(0);
  const [ratingMessages, dispatchRatingMessages] = React.useReducer(ratingReducer, RATING_INITIAL_STATE);
  const [ratingMessageFilters, dispatchMessageFilters] = React.useReducer(ratingMessagesFilterReducer, {
    RATING_FILTERS_INITIAL_STATE,
    RATING_SORT_INITIAL_STATE
  });
  const {
    t
  } = useTranslation();
  const {
    profile
  } = useExpertProfileContext();
  const {
    addFailureNotification
  } = useNotificationContext();
  const isPracticeGroup = () => {
    return profile === null || profile === void 0 ? void 0 : profile.groups.some(item => item.groupName === group.value && item.practiceGroup === true);
  };
  const groupSuggestions = React.useMemo(() => {
    const groupList = [];
    profile.groups.map(group => {
      if (group.membershipState === "active" && group.productionGroup && !group.qualityReviewGroup) {
        groupList.push({
          label: group.displayName,
          value: group.groupName,
          tenantName: group.tenantName
        });
      }
    });
    groupList.sort((group, nextGroup) => {
      if (group.label.toLowerCase() < nextGroup.label.toLowerCase()) {
        return -1;
      }
      if (group.label.toLowerCase() > nextGroup.label.toLowerCase()) {
        return 1;
      }
      return 0;
    });
    groupList.unshift({
      label: t("All Groups"),
      value: "all"
    });
    setGroup(groupList[0]);
    return groupList;
  }, [profile]);
  React.useEffect(() => {
    applyFilters();
  }, [ratingMessageFilters]);
  const ratingFilterExists = ratingMessageFilters.custRatingHundred || ratingMessageFilters.custRatingEighty || ratingMessageFilters.custRatingFifty || ratingMessageFilters.custRatingZero || ratingMessageFilters.qualityRatingHundrad || ratingMessageFilters.qualityRatingEighty || ratingMessageFilters.qualityRatingFifty || ratingMessageFilters.qualityRatingZero;
  const sortExists = ratingMessageFilters.dateSort || ratingMessageFilters.custRatingSort || ratingMessageFilters.qualityRatingSort;
  const updateRatingFilters = values => {
    dispatchMessageFilters({
      type: UPDATE_MESSAGES_FILTERS,
      payload: {
        ...ratingMessageFilters,
        ...values
      }
    });
  };
  const clearRatingState = type => {
    dispatchRatingMessages({
      type: RESET_RATING_MESSAGES
    });
    switch (type) {
      case "RESET_MESSAGES_FILTERS":
        return dispatchMessageFilters({
          type: RESET_MESSAGES_FILTERS
        });
      case "RESET_MESSAGES_SORT":
        return dispatchMessageFilters({
          type: RESET_MESSAGES_SORT
        });
      default:
        if (type === "RESET_ALL") {
          setGroup(groupSuggestions[0]);
        }
        return (ratingFilterExists || sortExists) && dispatchMessageFilters({
          type: RESET_MESSAGES_ALL
        });
    }
  };
  const getRatingMessage = (messageId, message) => {
    setRatingMessage({});
    fetchExpertRatingMessage(messageId, newMessage => {
      const expertRatingMessage = {
        ...newMessage,
        ...message,
        conversationState: {
          showExpertThumbnail: false,
          showExpertRating: true,
          type: "respond"
        },
        dialogues: newMessage.dialogues
      };
      if (message.reviewScore && expertRatingMessage.qualityReviewMessageId) {
        fetchExpertRatingMessage(expertRatingMessage.qualityReviewMessageId, reviewMessage => {
          var _reviewMessage$review;
          const ReviewMessage = {
            ...expertRatingMessage,
            reviewNotes: reviewMessage.reviewNotes,
            reviewCriteria: (_reviewMessage$review = reviewMessage.reviewCriteria) !== null && _reviewMessage$review !== void 0 ? _reviewMessage$review : []
          };
          setRatingMessage(ReviewMessage);
        });
      } else {
        setRatingMessage(expertRatingMessage);
      }
    });
  };
  const applyFilters = () => {
    dispatchRatingMessages({
      type: UPDATE_RATING_MESSAGES,
      payload: {
        loading: true
      }
    });
    const filters = [];
    const sort = [];
    const custFilter = [];
    const qualityFilter = [];
    setSort([]);
    setPage(1);
    Object.entries(ratingMessageFilters).filter(([key, value]) => value).map(([key, value]) => {
      switch (key) {
        case "custRatingEighty":
          return value && custFilter.push(filterRange.eighty);
        case "custRatingFifty":
          return value && custFilter.push(filterRange.fifty);
        case "custRatingZero":
          return value && custFilter.push(filterRange.zero);
        case "qualityRatingEighty":
          return value && qualityFilter.push(filterRange.eighty);
        case "qualityRatingFifty":
          return value && qualityFilter.push(filterRange.fifty);
        case "qualityRatingZero":
          return value && qualityFilter.push(filterRange.zero);
        default:
          return "";
      }
    });
    const custRatingTypeHasSelection = ratingMessageFilters.custRatingHundred || ratingMessageFilters.custRatingEighty || ratingMessageFilters.custRatingFifty || ratingMessageFilters.custRatingZero;
    const qualityTypeHasSelection = ratingMessageFilters.qualityRatingHundrad || ratingMessageFilters.qualityRatingEighty || ratingMessageFilters.qualityRatingFifty || ratingMessageFilters.qualityRatingZero;
    if (custRatingTypeHasSelection) {
      filters.push({
        type: "custRating",
        includedInRatingCalculation: ratingMessageFilters.custRatingHundred,
        threshold: custFilter
      });
    }
    if (qualityTypeHasSelection) {
      filters.push({
        type: "reviewScore",
        includedInRatingCalculation: ratingMessageFilters.qualityRatingHundrad,
        threshold: qualityFilter
      });
    }
    if (ratingMessageFilters.dateSort === true) {
      sort.push({
        fieldName: "date",
        order: ratingMessageFilters.dateSortDESC ? "desc" : "asc"
      });
    }
    if (ratingMessageFilters.custRatingSort === true) {
      sort.push({
        fieldName: "custRating",
        order: ratingMessageFilters.cusrRatingSortDESC ? "desc" : "asc"
      });
    }
    if (ratingMessageFilters.qualityRatingSort === true) {
      sort.push({
        fieldName: "reviewScore",
        order: ratingMessageFilters.qualityRatingSortDESC ? "desc" : "asc"
      });
    }
    setSort(sort);
    setFilters(filters);
  };
  const loadExpertRatingMessages = (page = 1, filters = [], sort = [], count = 500) => {
    const variables = {
      group,
      page,
      filters,
      sort,
      count
    };
    dispatchRatingMessages({
      type: SET_RATING_MESSAGES,
      payload: {
        ...ratingMessages,
        loading: true,
        hasError: true
      }
    });
    findExpertMessageList(variables, result => {
      const {
        expertRatingInfo,
        ratedMessages
      } = result;
      if (result.hasError) {
        addFailureNotification("Failed to find messages");
        dispatchRatingMessages({
          type: UPDATE_RATING_MESSAGES,
          payload: {
            ...ratingMessages,
            history: [],
            hasError: true,
            loading: false
          }
        });
      } else {
        setCustRating(expertRatingInfo.rating);
        setPageCount(ratedMessages.totalPages);
        setRatingMessagesCount(expertRatingInfo.ratingMessagesCount);
        dispatchRatingMessages({
          type: UPDATE_RATING_MESSAGES,
          payload: {
            ...ratingMessages,
            history: page === 1 ? ratedMessages.messages : [...ratingMessages.history, ...ratedMessages.messages],
            filtered: page === 1 ? ratedMessages.messages : [...ratingMessages.filtered, ...ratedMessages.messages],
            hasError: false,
            loading: false
          }
        });
      }
    });
  };
  return {
    profile,
    group,
    setGroup,
    page,
    setPage,
    filters,
    sort,
    pageCount,
    custRating,
    ratingMessagesCount,
    groupSuggestions,
    getRatingMessage,
    loadExpertRatingMessages,
    ratingMessages,
    ratingFilterExists,
    sortExists,
    ratingMessage,
    ratingMessageFilters,
    updateRatingFilters,
    clearRatingState,
    isPracticeGroup
  };
};